module.exports = __webpack_public_path__ + "img/robata_0.612d33e8.jpg";